import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {replace} from 'connected-react-router';

import {changeSetting} from 'common/actions/settings';

class BookARide extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.dispatch(changeSetting('serviceId', null));
    this.props.dispatch(replace('/'));
  }

  render() {
    return null;
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(BookARide);



// WEBPACK FOOTER //
// ./src/ondemand/containers/BookARide.js